import { useFragment } from '@apollo/client';

import { ProductDetailsProperties, ProductDetailsPropertiesSkeleton } from '@components/product/ProductDetailsProperties';

import {
  ProductDetailsPropertiesCatalogFragment,
  ProductDetailsPropertiesCatalogFragmentDoc,
  ProductDetailsPropertiesFragment,
  ProductDetailsPropertiesFragmentDoc,
} from './gql/graphql.v3.generated';

type Product = {
  __typename?: 'ProductDetails',
  id: number,
}

type Catalog = {
  __typename?: 'RootCatalog',
  id: string,
}

interface Props {
  className?: string,
  product?: Product,
  catalog?: Catalog | null,
  catalogSlug: string,
}

export const ProductDetailsPropertiesContainer: React.FC<Props> = ({
  className,
  product,
  catalog,
  catalogSlug,
}) => {
  const { data: productData, complete: productDataComplete } = useFragment<ProductDetailsPropertiesFragment>({
    fragment: ProductDetailsPropertiesFragmentDoc,
    from: product || null,
    variables: {
      catalogSlug,
    }
  });

  const { data: catalogData, complete: catalogDataComplete } = useFragment<ProductDetailsPropertiesCatalogFragment>({
    fragment: ProductDetailsPropertiesCatalogFragmentDoc,
    from: catalog || null,
  });

  if (!productDataComplete || !catalogDataComplete) {
    return (
      <ProductDetailsPropertiesSkeleton className={className} />
    );
  }

  if (productData && catalogData) {
    return (
      <ProductDetailsProperties
        className={className}
        product={productData}
        catalog={catalogData}
        characteristics={productData.characteristics}
      />
    );
  }

  return null;
};
